"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.AbortSignal = exports.AbortController = void 0;

var _cjsPonyfill = require("abortcontroller-polyfill/dist/cjs-ponyfill"); /* eslint-disable */



var getGlobal = function getGlobal() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {return self;}
  if (typeof window !== 'undefined') {return window;}
  if (typeof global !== 'undefined') {return global;}
  throw new Error('unable to locate global object');
};

//@ts-ignore
var AbortController = typeof getGlobal().AbortController === 'undefined' ? _cjsPonyfill.AbortController : getGlobal().AbortController;
//@ts-ignore
exports.AbortController = AbortController;var AbortSignal = typeof getGlobal().AbortController === 'undefined' ? _cjsPonyfill.AbortSignal : getGlobal().AbortSignal;exports.AbortSignal = AbortSignal;